import {
  ASSIGNEE_LIST,
  ASSIGNEE_LIST_V2,
  SPECIAL_ASSIGNEE_LIST,
} from 'enrollment-platform/pages/ApplicationQueue/constants'
import { useMemo } from 'react'
import useFeatureFlags from './useFeatureFlags'

const useAssigneeList = ({
  isIncludeSpecialAssignee = true,
}: {
  isIncludeSpecialAssignee?: boolean
}) => {
  const { flags } = useFeatureFlags()
  const isShowTwoVersionAssigneeEnabled =
    flags?.['admin.is-show-two-version-assignee-enabled']

  const assigneeList = useMemo(() => {
    return Array.from(
      new Set([
        ...ASSIGNEE_LIST_V2,
        ...(isShowTwoVersionAssigneeEnabled ? ASSIGNEE_LIST : []),
      ])
    )
  }, [isShowTwoVersionAssigneeEnabled])

  return [
    ...(isIncludeSpecialAssignee ? SPECIAL_ASSIGNEE_LIST : []),
    ...assigneeList,
  ]
}

export default useAssigneeList
